
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/shipping-boxes?${queryString}`);
    return response.data;
  },
  async add(payload) {
    const response = await https.post(`/shipping-boxes`, payload);
    return response.data;
  },

  async update(id, payload) {
    const response = await https.put(`/shipping-boxes/${id}`, payload);
    return response.data;
  },

  async deleteById(id) {
    const response = await https.delete(`/shipping-boxes/${id}`);
    return response.data;
  },
  async import(file) {
    const formData = new FormData();
    formData.append('excel_file', file);
    const response = await https.post(`/shipping-boxes/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
});

